export const ALL_CAMPAIGNS_LAST_NUM_DAYS = 30;

export const ACTIVE_CAMPAIGNS_TAB_KEY = 'Active';
export const INACTIVE_CAMPAIGNS_TAB_KEY = 'Inactive';
export const UNLAUNCHED_CAMPAIGNS_TAB_KEY = 'Unlaunched';
export const PAUSED_CAMPAIGNS_TAB_KEY = 'Paused';
